// extracted by mini-css-extract-plugin
export default {"container":"ModalReject_container__LZSW7","input":"ModalReject_input__0bHHu","modal":"ModalReject_modal__Mb4VN"};